import React, { useState } from 'react'
import { css } from '@emotion/core'
import { IconButton, Row } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'

const littleIcon = css`
  margin-top: 0px;
`
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */

export function DmcExpander({ header, buttonTestId = 'dmcExpander', afterIcon, body, headerAlign = 'start' }) {
  const [open, setOpen] = useState(false)

  return (
    <div>
      <Row alignX={headerAlign}>
        {header}
        <span css={littleIcon}>
          {open ? (
            <IconButton aria-label={buttonTestId} Icon={ArrowCaret} iconDirection="up" onClick={() => setOpen(!open)} />
          ) : (
            <IconButton
              aria-label={buttonTestId}
              Icon={ArrowCaret}
              iconDirection="down"
              onClick={() => setOpen(!open)}
            />
          )}
        </span>
        <span growX>{afterIcon}</span>
      </Row>
      {open && <div>{body}</div>}
    </div>
  )
}

/* eslint-enable jsx-a11y/interactive-supports-focus */
/* eslint-enable jsx-a11y/click-events-have-key-events */
